export const firePropagationEs = {
  firePropagation: {
    title: "AgriFireShield — Motor de Propagación",
    subtitle: "Modelo Rothermel (1972) con Fuel Models Agrícolas + humedad FAO-56",
    explainerTitle: "¿Qué hace esta herramienta?",
    explainerDesc: "Simula cómo se propaga un incendio sobre tu parcela usando datos reales (tipo de cultivo, humedad del suelo, meteorología). Compara el resultado usando nuestro modelo agrícola vs. un modelo estándar que trata todo como pasto seco — demostrando cómo un olivar irrigado actúa como cortafuegos natural.",
    parcelSelection: "Selección de Parcela",
    parcelSelectionDesc: "Elige una parcela real o usa el escenario demo mediterráneo",
    selectParcel: "Seleccionar parcela...",
    demoMediterranean: "🗺️ Demo Mediterráneo (datos ficticios)",
    realData: "DATOS REALES",
    demoMode: "MODO DEMO",
    demoModeDesc: "Mosaico mediterráneo simulado: olivo, viñedo, rastrojo, almendro. Sin datos reales de parcela.",
    crop: "Cultivo",
    fuel: "Fuel",
    irrigation: "Riego",
    dryland: "Secano",
    depletion: "Depleción",
    weatherConditions: "Condiciones Meteorológicas",
    weatherInitialized: "Valores inicializados con datos reales de tu parcela — puedes ajustarlos",
    weatherAdjust: "Ajusta las condiciones para la simulación",
    wind: "Viento",
    direction: "Dirección",
    temperature: "Temperatura",
    humidity: "Humedad",
    deterministic: "Determinístico (A vs B)",
    probabilistic: "Probabilístico (Monte Carlo)",
    simulations: "Simulaciones:",
    runSimulation: "Ejecutar Simulación",
    simulating: "Simulando...",
    animate: "Animar",
    keyResult: "Resultado clave:",
    keyResultDesc: "Con el modelo agrícola AgriFireShield, el fuego quemó",
    lessSurface: "menos superficie",
    keyResultReason: "que el modelo estándar, porque los cultivos irrigados (olivos, cítricos) actúan como cortafuegos naturales al tener mayor contenido de humedad en el combustible.",
    comparisonTitle: "Comparación: Modelo Agrícola vs Estándar",
    comparisonDesc: "Misma ignición, meteorología y terreno — sólo cambia el modelo de combustible.",
    usingRealData: " Usando datos reales de tu parcela.",
    agriModel: "🌿 AgriFireShield",
    agriModelSubtitle: "Modelo agrícola con humedad FAO-56",
    standardModel: "🔥 Modelo Estándar",
    standardModelSubtitle: "Todo como pasto seco homogéneo (GR4)",
    burnedSurface: "Superficie quemada",
    maxSpreadRate: "Velocidad máx. propagación",
    howToReadMaps: "¿Cómo leer estos mapas?",
    mapLegend1: "= zona quemada. El color indica el tiempo de llegada del fuego: amarillo = rápido, rojo = tardío.",
    mapLegend2: "= punto de ignición (donde comienza el fuego).",
    mapLegend3: "= no alcanzadas por el fuego en los",
    mapLegend3b: "minutos de simulación.",
    mapLegend4: "Los colores de fondo representan tipos de cultivo. Los cultivos irrigados frenan el fuego.",
    mapLegend5: "Toda la superficie se trata como pasto seco, sin considerar cultivos reales.",
    warmColors: "Colores cálidos (amarillo → rojo)",
    whitePointRedBorder: "Punto blanco con borde rojo",
    darkAreas: "Zonas oscuras",
    agriModelLeft: "Modelo Agrícola (izquierda):",
    standardModelRight: "Modelo Estándar (derecha):",
    landUseMosaic: "Mosaico de usos del suelo",
    lessBurnedSurface: "Menos superficie quemada",
    slowerPropagation: "Propagación más lenta",
    computationTime: "Tiempo de cálculo",
    modelTransparency: "Transparencia del Modelo",
    engine: "Motor:",
    version: "Versión:",
    reference: "Referencia:",
    innovation: "Innovación:",
    knownLimitations: "⚠️ Limitaciones Conocidas",
    coreEquation: "Ecuación Central",
    rosEquation: "R = IR · ξ · (1 + φw + φs) / (ρb · ε · Qig)",
    rosDesc: "Velocidad de propagación (Rothermel 1972)",
    fuelMoistureIntegration: "Integración de Humedad del Combustible",
    fuelMoistureDesc: "La humedad del combustible muerto (Mf) se acopla dinámicamente con el balance hídrico FAO-56. Los cultivos irrigados muestran Mf 2–5× mayor que los modelos estándar, reduciendo la velocidad de propagación un 60–90%.",
    cellularAutomaton: "Autómata Celular",
    cellularAutomatonDesc: "Malla 60×60, propagación a 8 vecinos con ponderación direccional del viento y corrección por pendiente.",
    agriculturalFuelModels: "Modelos de Combustible Agrícola",
    fuelModelCount: "8 modelos específicos por cultivo",
    fuelModelDesc: "Parámetros de lecho de combustible (carga, ratio SAV, profundidad, humedad de extinción) calibrados para agricultura mediterránea.",
    scientificBasis: "Base Científica",
    peerReviewed: "Fundamento revisado por pares",
    validationStatus: "Estado de Validación",
    validationDesc: "Calibrado con literatura. Validación de campo pendiente (ESA BASS PoC Q3 2026).",
    architectureTitle: "Arquitectura",
    architectureDesc: "Supabase Edge Function · Deno runtime · <500ms determinístico · Ensemble Monte Carlo",
    dataInputs: "Datos de Entrada",
    dataInputsDesc: "Geometría real de parcela · tipo cultivo → modelo combustible · depletion_mm FAO-56 → Mf · Meteorología real de NASA POWER",
    probMapTitle: "Mapa de Probabilidad de Incendio — Monte Carlo",
    probMapSimulations: "simulaciones",
    probMapDesc1: "Cada píxel muestra la probabilidad de ser alcanzado por el fuego.",
    probMapDesc2: "simulaciones con perturbaciones aleatorias en viento (±20%), dirección (±30°) y humedad (±15%).",
    howToReadProbMap: "¿Cómo leer este mapa?",
    probRed: "Rojo intenso (100%)",
    probRedDesc: "= Esta zona se quema en TODAS las simulaciones, independientemente de variaciones meteorológicas.",
    probYellow: "Amarillo (50%)",
    probYellowDesc: "= Se quema en la mitad de las simulaciones — zona de riesgo variable.",
    probBlue: "Azul (10-20%)",
    probBlueDesc: "= Baja probabilidad — sólo se quema en los peores escenarios de viento.",
    probNone: "Sin color",
    probNoneDesc: "= Probabilidad 0% — zona protegida (típicamente cultivos irrigados).",
    p10Optimistic: "P10 — Optimista",
    p10Desc: "Escenario favorable",
    p50Median: "P50 — Mediana",
    p50Desc: "Escenario probable",
    p90Pessimistic: "P90 — Pesimista",
    p90Desc: "Peor escenario razonable",
    totalTime: "Tiempo total",
    perturbations: "Perturbaciones:",
    windPert: "Viento",
    dirPert: "Dir",
    hrPert: "HR",
    ignitionLabel: "🔥 Ignición",
    reductionTitle: "Reducción de Daño con FAO-56",
    withoutFAO: "Sin FAO-56",
    withFAO: "Con FAO-56",
    less: "MENOS",
    hectaresProtected: "hectáreas protegidas por humedad del suelo",
    fireContained: "Fuego contenido",
    freeSpread: "Propagación libre",
    firebreakWorked: "✅ Olivos irrigados (θ=0.28 m³/m³) frenaron la propagación",
    scientificExplanation: "El modelo AgriFireShield integra la humedad volumétrica del suelo (θ) calculada con FAO-56 directamente en las ecuaciones de propagación de Rothermel. Los cultivos irrigados (θ=0.28 m³/m³) actúan como cortafuegos natural, reduciendo el Rate of Spread (ROS) de 0.018 m/s a prácticamente cero.",
    behavior: "Comportamiento",
    explainerHow: "¿Cómo funciona?",
    explainerText: "Simulamos un incendio en un mosaico mediterráneo. A la izquierda, el modelo AgriFireShield usa la humedad real del suelo (FAO-56) para frenar el fuego en cultivos irrigados. A la derecha, el modelo estándar trata todo como pasto seco.",
    explainerCircle: "El tamaño del círculo es proporcional al área quemada.",
    demoDescription: "Mosaico mediterráneo simulado: olivar irrigado rodeado de matorral y pasto.",
    deterministicBtn: "Determinístico",
    simulationsLabel: "Simulaciones:",
    simulatingBtn: "Simulando...",
    runSimBtn: "Ejecutar Simulación",
    animatingBtn: "▶ Animando...",
    viewPropagationBtn: "▶ Ver Propagación",
    irrigationLabel: "Riego",
    drylandLabel: "Secano",
    depletionLabel: "Depleción",
    coreEquationLabel: "Ecuación base",
    fao56Integration: "Integración FAO-56",
    fao56IntegrationDesc: "La humedad del suelo (θ) reduce la velocidad de propagación en cultivos irrigados hasta un 95%.",
    fuelModelsTitle: "8 Modelos de Combustible Agrícola",
    fuelModelsDesc: "Olivo irrigado/secano, viñedo, cítricos, cereal, rastrojo, barbecho, almendro.",
    knownLimitationsTitle: "Limitaciones conocidas",
    mcTitle: "Monte Carlo",
    mcDesc: "Cada simulación perturba viento y humedad para cuantificar la incertidumbre.",
    mcPerturbationsTitle: "Perturbaciones Monte Carlo",
    mcWindLabel: "Viento",
    mcDirLabel: "Dirección",
    mcHumLabel: "Humedad",
    terrainOliveIrr: "🫒 Olivo (riego)",
    terrainVineyard: "🍇 Viñedo",
    terrainStubble: "🌾 Rastrojo",
    terrainShrub: "🌲 Matorral",
    terrainBurned: "🔥 Quemado",
    terrainFirebreak: "💧 Cortafuegos",
    terrainCitrus: "🍊 Cítricos",
    terrainGrass: "🌿 Pasto",
    terrainAlmond: "🌰 Almendro",
    disclaimerTitle: "Prototipo validado — Calibración de campo parcial pendiente",
    disclaimerText: "Prototipo de investigación. Las ecuaciones núcleo de Rothermel (1972) se comprueban con <15% de error frente a los valores publicados por Anderson 1982 (USDA GTR-122) para los modelos NFFL 1 y 3 en nuestros tests. Los modelos de combustible agrícolas usan parámetros de literatura (NO calibrados en campo). El acoplamiento de humedad FAO-56 usa coeficientes empíricos (0.10–0.25) pendientes de validación en campo. No es una herramienta operativa de extinción, no sirve para decisiones de evacuación y no sustituye a Protección Civil ni a los servicios oficiales de emergencia.",
    fuelLabels: {
      AGR_OLIVE_IRR: "🫒 Olivo irrigado",
      AGR_OLIVE_DRY: "🫒 Olivo secano",
      AGR_VINEYARD: "🍇 Viñedo",
      AGR_CITRUS: "🍊 Cítricos",
      AGR_CEREAL_STUBBLE: "🌾 Rastrojo cereal",
      AGR_CEREAL_GREEN: "🌾 Cereal verde",
      AGR_ALMOND: "🌰 Almendro",
      GR1: "🌿 Pasto bajo",
      GR4: "🌾 Pasto alto",
      SH2: "🌲 Matorral",
    }
  }
};
